import type { ResourceSteeringStatus } from '@/features/resource/types'

export type FlexBalanceResource = {
  name: string
  site: string
  resourceId: string
  steeringStatus: ResourceSteeringStatus | null
}

export type FlexBalanceResourcePage = {
  values: FlexBalanceResource[]
  currentPage: number
  totalCount: number
}

export enum SteeringCommand {
  STEER = 'STEER',
  RELEASE = 'RELEASE',
}
